(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-complete-core-system"] && !Shopify.designMode) return;
  try {
    
  class SvCoreSystem {
    constructor(root) {
      this.root = root;
      this.status = root.querySelector('[data-core-status]');
      this.sectionId = root.dataset.sectionId;
      this.currentProductId = root.dataset.currentProductId;
      this.bind();
      this.track('sv_module_impression', {});
      this.refreshCart();
    }

    bind() {
      this.root.querySelectorAll('[data-sv-add]').forEach((button) => {
        button.addEventListener('click', () => this.add(button));
      });
      this.root.querySelectorAll('[data-sv-quick-view]').forEach((button) => {
        button.addEventListener('click', () => this.openQuickView(button));
      });
      this.root.querySelectorAll('[data-sv-dialog]').forEach((dialog) => {
        dialog.querySelector('[data-sv-dialog-close]')?.addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
        dialog.addEventListener('close', () => this.activeQuickViewTrigger?.focus());
      });
      this.root.querySelectorAll('[data-sv-product-link]').forEach((link) => {
        link.addEventListener('click', () => this.track('sv_recommendation_click', this.details(link)));
      });
      this.root.querySelector('[data-sv-concierge]')?.addEventListener('click', (event) => {
        event.preventDefault();
        this.track('sv_skin_concierge_click', { destination: 'skin_concierge' });
        this.openConcierge();
      });
    }

    openQuickView(button) {
      const dialog = this.root.querySelector(`#${button.dataset.dialogId}`);
      if (!dialog || typeof dialog.showModal !== 'function') return;
      this.activeQuickViewTrigger = button;
      dialog.showModal();
      this.track('sv_recommendation_quick_view', this.details(button));
    }

    announce(button, message) {
      this.status.textContent = message;
      const dialogStatus = button.closest('dialog')?.querySelector('[data-sv-dialog-status]');
      if (dialogStatus) dialogStatus.textContent = message;
    }

    openConcierge(attempt = 0) {
      const widget = window.HubSpotConversations && window.HubSpotConversations.widget;
      if (widget && typeof widget.open === 'function') {
        widget.open();
        return;
      }
      if (attempt < 39) {
        window.setTimeout(() => this.openConcierge(attempt + 1), 250);
      }
    }

    details(element) {
      return {
        core_system: element.dataset.coreSystem || '',
        recommendation_type: element.dataset.cardType || '',
        product_handle: element.dataset.productHandle || '',
        variant_id: element.dataset.variantId || ''
      };
    }

    async refreshCart() {
      try {
        const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        if (!response.ok) return null;
        const cart = await response.json();
        const ids = new Set(cart.items.map((item) => String(item.variant_id)));
        this.root.querySelectorAll('[data-sv-add]').forEach((button) => {
          const variantId = button.dataset.variantId;
          const components = (button.dataset.componentVariants || '').split(',').filter(Boolean);
          const duplicate = ids.has(variantId) || components.some((id) => ids.has(id));
          button.disabled = duplicate;
          button.textContent = duplicate ? button.dataset.inCartLabel : button.dataset.addLabel;
          button.dataset.duplicate = duplicate ? 'true' : 'false';
        });
        return cart;
      } catch (error) {
        return null;
      }
    }

    async add(button) {
      const detail = this.details(button);
      const cart = await this.refreshCart();
      if (button.dataset.duplicate === 'true') {
        this.announce(button, button.dataset.duplicateMessage);
        this.track('sv_cart_deduplicated', { ...detail, cart_item_count: cart?.item_count || 0 });
        return;
      }
      button.disabled = true;
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] })
        });
        if (!response.ok) throw new Error('Add failed');
        this.announce(button, button.dataset.addedMessage);
        this.track('sv_recommendation_add_to_cart', detail);
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        await this.refreshCart();
      } catch (error) {
        button.disabled = false;
        this.announce(button, button.dataset.errorMessage);
      }
    }

    track(name, detail) {
      const payload = {
        event: name,
        section_id: this.sectionId,
        source: 'complete_core_system',
        current_product_id: this.currentProductId,
        ...detail
      };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      this.root.dispatchEvent(new CustomEvent('sv:analytics', { bubbles: true, detail: payload }));
    }
  }

  document.querySelectorAll('[data-sv-core-system]').forEach((root) => new SvCoreSystem(root));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-product-concierge-cta"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sv-product-concierge]').forEach((root) => {
    const trigger = root.querySelector('[data-sv-product-concierge-trigger]');
    if (!trigger) return;
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      const payload = {
        event: 'sv_skin_concierge_click',
        section_id: root.dataset.sectionId,
        source: 'product_concierge_cta',
        current_product_id: root.dataset.currentProductId,
        destination: 'skin_concierge'
      };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      root.dispatchEvent(new CustomEvent('sv:analytics', { bubbles: true, detail: payload }));
      let attempt = 0;
      const openWidget = () => {
        const widget = window.HubSpotConversations && window.HubSpotConversations.widget;
        if (widget && typeof widget.open === 'function') {
          widget.open();
          return;
        }
        attempt += 1;
        if (attempt < 40) window.setTimeout(openWidget, 250);
      };
      openWidget();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
